import React from 'react';
import CCMRSSyle from './style';
import slideSystem from '../../components/pageSlideSystem/slideSystem';
import Page00 from './pages/page00';
import Page01 from './pages/page01';
import Page02 from './pages/page02';
import Page03 from './pages/page03';
import Page04 from './pages/page04';
import Page06 from './pages/page06';
import Page07 from './pages/page07';
import Page08 from './pages/page08';
import Page09 from './pages/page09';
import Page10 from './pages/page10';
import Page11 from './pages/page11';
import Page12 from './pages/page12';
import Page13 from './pages/page13';
import Page14 from './pages/page14';
import Page15 from './pages/page15';
import Page16 from './pages/page16';
import Page17 from './pages/page17';
import coursesInfo from '../payment/courseInformation';

export default function Ccmrs() {
	let courseInfo = coursesInfo[0];

	let CCMRSlides = slideSystem(
		[
			Page00,
			Page01,
			Page02,
			Page03,
			Page04,
			Page06,
			Page07,
			Page08,
			Page09,
			Page10,
			Page11,
			Page12,
			Page13,
			Page14,
			Page15,
			Page16,
			Page17,
		],
		{
			next: scrollToTop,
			back: scrollToTop,
		},
		{courseInfo: courseInfo}
	);
	let style = CCMRSSyle();
	return <>{CCMRSlides}</>;
}

function scrollToTop() {
	if ('scrollRestoration' in history) {
		history.scrollRestoration = 'manual';
	}

	window.scrollTo(0, 0);
}
